import { useCallback, useState } from 'react';
import { startRecording, stopRecording } from '../../api/fetchRecording';

import CameraEnhanceIcon from '@material-ui/icons/CameraEnhance';
import { IconButton } from '@material-ui/core';
import styles from './styles';
import Tooltip from '@material-ui/core/Tooltip';
import Modal from '@material-ui/core/Modal';
import VideoFilter from '../VideoFilter';
import { SET_BACKGROUND_FILTER } from 'store/WaitingRoom/waitingRoomAction';
import { useDispatch, useSelector } from 'react-redux';

export default function HlsFilterButton({
  classes,
  Publisher,
  open,
  onClose,
  setOpen,
}) {
  const localClasses = styles();
  const [modalStyle] = useState(getModalStyle);
  const dispatch = useDispatch();
  const [videoFilter, setVideoFilter] = useState({
    filterName: '',
    filterPayload: '',
  });
  const state = useSelector((state) => state.waitingRoomReducer);

  function rand() {
    return Math.round(Math.random() * 20) - 10;
  }

  function getModalStyle() {
    const top = 50;
    const left = 50;

    return {
      top: `${top}%`,
      left: `${left}%`,
      transform: `translate(-${top}%, -${left}%)`,
    };
  }

  const handleChangeVideoFilter = useCallback(
    async (filterName, filterPayload) => {
      if (Publisher && filterName) {
        switch (filterName) {
          case 'reset':
            await Publisher.clearVideoFilter();
            dispatch({
              type: SET_BACKGROUND_FILTER,
              payload: { filterName: '', filterPayload: '' },
            });
            localStorage.setItem('filterName', '');
            localStorage.setItem('filterPayload', '');
            break;

          case 'blur':
            await Publisher.applyVideoFilter({
              type: 'backgroundBlur',
              blurStrength: filterPayload,
            });
            dispatch({
              type: SET_BACKGROUND_FILTER,
              payload: { filterName, filterPayload },
            });
            localStorage.setItem('filterName', filterName);
            localStorage.setItem('filterPayload', filterPayload);
            break;

          case 'backgroundImage':
            await Publisher.applyVideoFilter({
              type: 'backgroundReplacement',
              backgroundImgUrl: filterPayload,
            });
            dispatch({
              type: SET_BACKGROUND_FILTER,
              payload: { filterName, filterPayload },
            });
            localStorage.setItem('filterName', filterName);
            localStorage.setItem('filterPayload', filterPayload);
            break;

          default:
          // do nothing
        }
      }
    },
    [Publisher]
  );

  const body = (
    <div style={modalStyle} className={`${localClasses.paper} important-width`}>
      <span className='close-modal' onClick={onClose}>
        &times;
      </span>
      <VideoFilter handleChangeVideoFilter={handleChangeVideoFilter} />
    </div>
  );

  return (
    <>
      {/* <Tooltip title={'Apply Video Filter'} aria-label='add'>
        <IconButton
          edge='start'
          color='inherit'
          aria-label='mic'
          onClick={() => setOpen(true)}
          className={classes.toolbarButtons}
        >
          <CameraEnhanceIcon fontSize='inherit' />
        </IconButton>
      </Tooltip> */}
      <Modal
        open={open}
        onClose={onClose}
        aria-labelledby='simple-modal-title'
        aria-describedby='simple-modal-description'
      >
        {body}
      </Modal>
    </>
  );
}
